/* eslint max-classes-per-file: 0 */

import {
  LkPassport as Data,
  LkPassportCollection as Collection,
} from '@/typings/api/Passport'
import { LkPassportApi as Api } from '@/api/resources'

import { Fabric } from '@/store/createCrudModule'
import { BaseApiParams } from '@/typings/common'


const { TransformerParams, Adapter } = Fabric<Data, Collection>()

export class PassportLKTransformerParams extends TransformerParams {
  protected per_page = 'per_page';
}

export class LKPassportsAdapter extends Adapter<Api> {
    public readonly api = new Api();

    public readonly transformerParams = new PassportLKTransformerParams();

    public getAll<P extends BaseApiParams, RP extends BaseApiParams>(payload?: P, rawParams?: RP) {
      const { params, options } = this.transformerParams.getAll(payload, rawParams)

      return this.api.getPassports(params, options)
        .then((response) => this.transformerData.getAll(response, payload))
    }
}
